import RegistroCaja from '../components/RegistroCaja'

export default function CajaCobranzasPage() {
  return <RegistroCaja tipo="cobranza" />
}
